export const USER_ROLES = {
  ADMIN: 'ADMIN',
  EMPLOYEE: 'EMPLOYEE',
};

export const USER_STATUS = {
  PENDING: 'PENDING',
  ACTIVE: 'ACTIVE',
  DORMANT: 'DORMANT',
  DISMISSED: 'DISMISSED',
};

export const BOOKING_STATUS = {
  PENDING_REVIEW: 'pending-review',
  UPCOMING: 'upcoming',
  IN_PROGRESS: 'in-progress',
  REJECTED: 'rejected',
  CANCELLED: 'cancelled',
  FAILED: 'failed',
  WRAPPING_UP: 'wrapping-up',
  COMPLETED: 'completed',
};
